import { useMutation } from '@apollo/client';
import { useAccount } from 'shared/domains/users';
import { ConnectCompanyEsigningProviderDocument } from './mutation.gql';
export const useConnectEsigningProvider = () => {
    const { data } = useAccount();
    const { companyId = '' } = data;
    const [mutate, rest] = useMutation(ConnectCompanyEsigningProviderDocument);
    const connectProvider = (esigningProviderId) => {
        mutate({ variables: { input: { companyId, esigningProviderId } } });
    };
    return Object.assign({ connectProvider }, rest);
};
